/**
 * Bootstrap — wire UI to engine.
 */

import { initApp } from './ui/app';
import './styles/main.css';
import './styles/editor.css';
import './styles/dark.css';

document.addEventListener('DOMContentLoaded', () => {
  initApp();
});
